const React = require("react");
const { HelmetProvider } = require("react-helmet-async");

exports.wrapRootElement = ({ element }) => {
  return (
          <HelmetProvider>
            {element}
          </HelmetProvider>
        );
};

// exports.onRenderBody = ({ setHeadComponents }) => {
//   setHeadComponents([
//     <script
//       key="formspree"
//       src="https://formspree.io/f/mqkjronq"
//       integrity="sha384-oqVuAfXRKap7fdgcCY5uykM6+R9GqQ8K/uxDA8TxeFRgT91xV5Z4JXrM7V+eC2QK"
//       crossOrigin="anonymous"
//     />,
//   ]);
// };
